import { render, staticRenderFns } from "./RadioListSection.vue?vue&type=template&id=33c9f48e&scoped=true"
import script from "./RadioListSection.vue?vue&type=script&lang=ts"
export * from "./RadioListSection.vue?vue&type=script&lang=ts"
import style0 from "./RadioListSection.vue?vue&type=style&index=0&id=33c9f48e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c9f48e",
  null
  
)

export default component.exports